
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registrazione-e-preferenze",
      function () {
        return require("private-next-pages/registrazione-e-preferenze/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registrazione-e-preferenze"])
      });
    }
  